
import {Vue, Component, Emit, Prop} from 'vue-property-decorator';
import {materiaApi} from '@/api';
import formHelper from '../../../js/materia/materia.helper';
import CourseInfo from '@/components/Modal/CourseInfo.vue';
import Empty from '@/components/Empty/index.vue';
import Using_Class from './using_class.vue';
@Component({
    components: {
        CourseInfo,
        Empty,
        Using_Class
    }
})
export default class Material extends Vue {
    //===================================data区域begin
    courseNum: number = -1;
    query: any = {
        subject: '',
        source: '',
        grade: '',
        name: ''
    };
    columns: any = formHelper.columns;
    pager: any = {
        default: {
            pagesize: 10,
            pagenum: 1,
            total: 0,
            rows: []
        }
    };
    courseLoading: boolean = false;
    schoolId: any = [];
    selectedFile: number = 0;

    showCourseDetails = false;
    record = {};
    subjectList: any = [];
    sourceList: any = [
        {value: 'purchase', label: '渠道采购'},
        {value: 'createByTeacher', label: '教师创作'}
    ];
    phases = undefined;
    phasesList = [
        {value: 'primary', label: '小学'},
        {value: 'junior', label: '初中'},
        {value: 'senior', label: '高中'}
    ];
    // 表格课程名称是否显示气泡提示框
    courseNamePop: boolean = false;
    // 表格学段是否显示气泡提示框
    coursePhasesPop: boolean = false;
    // 表格班级名称是否显示气泡提示框
    classNamePop: boolean = false;
    showClass: boolean = false;
    recordClass: any = {};
    //===================================data区域end

    //===================================computed区域begin
    //===================================computed区域end

    //===================================methods区域begin
    customRow() {
        return {
            on: {
                mouseenter: (record: any) => {
                    const row = record.srcElement.children;
                    row[1].style.color = '#1456ed';
                    row[1].style.cursor = 'pointer';
                    if (row[6].innerText != '暂无') {
                        row[6].style.color = '#1456ed';
                        row[6].style.cursor = 'pointer';
                    }
                    // 课程名称
                    if (row[1].offsetWidth != row[1].scrollWidth) {
                        this.courseNamePop = true;
                    } else {
                        this.courseNamePop = false;
                    }
                    // 学段
                    if (row[4].offsetWidth != row[4].scrollWidth) {
                        this.coursePhasesPop = true;
                    } else {
                        this.coursePhasesPop = false;
                    }
                },
                mouseleave: (record: any) => {
                    const row = record.srcElement.children;
                    row[1].style.color = 'rgba(0,0,0,0.9)';
                    row[1].style.cursor = 'auto';
                    row[6].style.color = 'rgba(0,0,0,0.9)';
                    row[6].style.cursor = 'auto';
                },
                click: (record: any) => {
                    const row = record.srcElement.parentElement.parentElement.parentElement.parentElement.children;
                    if (row[1]) {
                        row[1].style.color = 'rgba(0,0,0,0.9)';
                        row[1].style.cursor = 'auto';
                    }
                    if (row[6]) {
                        row[6].style.color = 'rgba(0,0,0,0.9)';
                        row[6].style.cursor = 'auto';
                    }
                }
            }
        };
    }

    // 获取课程类型数据
    getSubject() {
        let me = this;
        materiaApi.getSubjectData({
            context: me,
            success(data: any, parameters: any) {
                me.subjectList = data.data.subjects;
            },
            error(error: any, message: string, parameters: any) {
                me.$message.error(message);
            }
        });
    }

    getList() {
        let me = this;
        me.courseLoading = true;
        let schoolIdList = [];
        schoolIdList.push(me.schoolId);

        let courseIdList: any = [];
        let data: any = {
            schoolIdList: [schoolIdList],
            page: me.pager.default.pagenum,
            pagesize: me.pager.default.pagesize,
            courseName: me.query.name,
            phases: me.phases,
            source: me.query.source,
            subject: me.query.subject
        };
        materiaApi.getListV2({
            context: me,
            data: data,
            success(data: any) {
                let objectList = data.data;
                for (let i = 0; i < data.data.length; i++) {
                    courseIdList.push(data.data[i].courseId);
                }
                // console.log(objectList);

                //将接口返回的数据进行处理
                for (var i = 0; i < objectList.length; i++) {
                    objectList[i].type === 'school' ? (objectList[i].type = '学校') : (objectList[i].type = '教研员');
                    if (objectList[i].course.phases[0] == 'primary') {
                        objectList[i].course.phases = '小学';
                    } else if (objectList[i].course.phases == 'junior') {
                        objectList[i].course.phases = '初中';
                    } else if (objectList[i].course.phases == 'senior') {
                        objectList[i].course.phases = '高中';
                    } else if (objectList[i].course.phases == 'vocational') {
                        objectList[i].course.phases = '中职';
                    } else if (objectList[i].course.phases == 'professional') {
                        objectList[i].course.phases = '高职';
                    }
                }
                if (me.courseNum == -1) {
                    me.courseNum = data.data.length;
                }
                me.pager.default.rows = objectList;
                me.pager.default.total = data.data.length;
                me.courseLoading = false;
                // me.initClassName(courseIdList);
            },
            error(error: any, message: string) {
                me.$message.error(message);
                me.courseLoading = false;
            }
        });
    }
    // 查看使用班级
    checkClass(record: any) {
        this.recordClass = record;
        this.showClass = true;
    }
    // 查看课程详情
    handleSee(record: {}) {
        this.record = record;
        this.showCourseDetails = true;
    }
    // 查看关联班级
    handleCourse(record: any) {
        this.$router.push({
            path: '/school/materia/meteria_class',
            query: {
                courseId: record.courseId,
                courseName: record.course.name
            }
        });
    }
    changeSubject(value: any) {
        this.query.subject = value;
        // console.log(this.query.subject);
        this.getList();
    }
    changeSource(value: any) {
        this.query.source = value;
        this.pager.default.pagenum = 1;
        this.pager.default.rows = [];
        this.getList();
    }
    changePhases(value: undefined) {
        this.phases = value;
        this.pager.default.pagenum = 1;
        this.pager.default.rows = [];
        this.getList();
    }
    queryList() {
        this.pager.default.pagenum = 1;
        this.pager.default.rows = [];
        this.getList();
    }

    paginationChange(page: number, pageSize: number) {
        this.pager.default.pagenum = page;
        // this.getList();
    }
    //===================================methods区域end

    created() {
        let value = window.localStorage.getItem('aicp_school_materials_$state_aicp_school_materials');
        this.schoolId = JSON.parse(value as string).schoolId;
        this.getList();
        this.getSubject();
    }
}
